export const socketConfig = {
  url: "wss://api.dono.gg",
};
